import * as R from 'ramda';
// common
import { menuRoutesConfig } from '../common/settings';
// helpers
import { getCurrentPathname } from './route';
import { isNotNilAndNotEmpty } from './helpers';
//////////////////////////////////////////////////

const getCurrentMenuItem = () => {
  const path = getCurrentPathname();

  let currentItem = '';

  if (isNotNilAndNotEmpty(path)) {
    R.forEachObjIndexed(
      (config, key) => {
        const isRegExp = R.any((regExp) => regExp.test(path), config.regExps);
        const isPath = R.any((configPath) => R.equals(configPath, path), config.paths);

        if (R.or(isRegExp, isPath)) {
          currentItem = key;
        }
      },
      menuRoutesConfig,
    );
  }

  return currentItem;
};

export {
  getCurrentMenuItem,
};
